import CommonHeading from "../../../../Components/CommonHeading";
import TableHead from "./TableHead";
import { useFormik } from "formik";
import * as Yup from "yup";
import Searchbar from "../../../../Components/Searchbar";
import { useCallback } from "react";
import ExportExcel from "../../../../Components/ExportExcel";
import { Link } from "react-router-dom";
import InfoModule from "../../../../Components/InfoModule";
import { useFinishedStudents } from "../../../../Store/ReportsStore/FinishedStudentsStore";
import Selector from "./Select";
import { useMemo } from "react";
import DateSection from "./DateSection";
import FormControlLabelPosition from "./CheckBox";
import { useTranslation } from "react-i18next";

export default function Heading() {
  const {
    loadItems,
    branches,
    updateParams,
    queryParams,
    setLoading,
    absences_count,
  } = useFinishedStudents();
  const { t } = useTranslation();

  const searchAction = useCallback(async (payload) => {
    updateParams({ search_query: payload.term, page: 1 });
    setLoading(true);
    await loadItems(
      new URLSearchParams({
        ...queryParams,
        page: 1,
        search_query: payload.term,
      }).toString()
    );
    setLoading(false);
  });

  const initialValues = {
    term: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      term: Yup.string().min(1, t("Qidiruvni kiriting!")),
    }),
    onSubmit: (values) => {
      searchAction({
        term: values.term,
      });
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue("term", e.target.value);
    searchAction({
      term: e.target.value,
    });
  };

  const optionsBranch = useMemo(() => {
    return (
      branches?.map((element) => ({
        label: element.title,
        value: element.id,
      })) || []
    );
  }, [branches]);

  const user = JSON.parse(localStorage.getItem("token"));

  const queryString = new URLSearchParams({
    ...queryParams,
    download: "excel",
    token: user.access || "",
  }).toString();

  return (
    <CommonHeading
      topItems={
        <>
          <Searchbar
            value={formik.values.term}
            handleChange={(e) => handleChange(e)}
            handleSubmit={formik.handleSubmit}
          />
          <Selector options={optionsBranch} property={t("Filiallar")} />
          <DateSection />
          <FormControlLabelPosition />
          <InfoModule title={absences_count} />
        </>
      }
      rightItems={
        <Link
          to={
            `https://admin.smartportal.uz/api/reports/successfully-finished-students/?` +
            queryString
          }
          download
          target={"_blank"}
        >
          <ExportExcel />
        </Link>
      }
      tableHead={<TableHead />}
    />
  );
}
